export const environment = {
    apiUrl: 'https://healthcare.adminapi.digicoffer.com',
    npsUrl: 'https://devadminapi.healthcare.digicoffer.com',
    // product: 'hospitalcare',
    production: true
};